<template>
    <div class="moodboard__result">
        <div class="row">
            <div class="col-12">
                <h2 class="result__headline">{{ $t('results') }}</h2>
            </div>
            <template v-if="decors === null">
                <template v-for="placeholder in showedDecors">
                    <div class="col-6 col-md-4 col-lg-2">
                        <div class="result__placeholder">
                            <img class="placeholder__spinner" alt="loading spinner" src="../assets/icon-spinner.svg" />
                        </div>
                    </div>
                </template>
            </template>
            <template v-for="(decorSet, column) in decors">
                <div class="col-6 col-md-4 col-lg-2" :class="debug ? 'debug': ''">
                    <template v-for="(decor, row) in decorSet">
                        <div v-if="debug">
                            <global-material-tile :entity="decor" />
                        </div>

                        <template v-else>
                            <div v-if="showedDecors[column] === row">
                                <global-material-tile :entity="decor">
                                    <div slot="content-wrapper" class="button-wrapper bottom left">
                                        <button class="button button--primary" @click="newSuggestion(column, decorSet.length)">{{ $t('newMatch') }}</button>
                                    </div>
                                </global-material-tile>
                            </div>
                        </template>
                    </template>
                </div>
            </template>
        </div>
        <div class="button-wrapper bottom right spaced--responsive full-width--xs spacer--top-none">
            <button v-if="showRoomdesignerButton" class="button button--secondary icon--before icon--roomdesigner" :disabled="roomdesignerButtonIsDisabled" @click="showRoomdesignerModal = true">{{ $t('toRoomDesigner') }}</button>
            <button class="button button--primary icon--before icon--wishlist-empty" :disabled="paletteIsOnWishlist()" @click="addToWishlist">{{ $t('savePalette') }}</button>
        </div>
        <global-roomdesigner-selection v-if="showRoomdesignerButton" @done="showRoomdesignerModal = false" :initialData="roomdesignerModalData" />
    </div>
</template>

<script>
import GlobalMaterialTile from "@global/global-elements/global-material-tile/global-material-tile.vue";
import {shopUtilities} from '@global/shop-utilities/shop-utilities';
import {cookieUtils} from '@utilities/cookie-utils/cookie-utils';
import {SalToast} from '@utilities/sal-toast/sal-toast';
import GlobalRoomdesignerSelection from '../../../../../global/global-elements/global-roomdesigner/global-roomdesigner-selection';

export default {
    name: "moodboard-result",
    components: {GlobalRoomdesignerSelection, GlobalMaterialTile},
    data: function () {
        return {
            showedDecors: [0,0,0,0,0,0],
            showedDecorIds: ['','','','','',''],
            debug: false,
            showRoomdesignerModal: false,
            showRoomdesignerButton: !!window.roomdesignerUrl
        }
    },
    props: {
        decors: null
    },
    watch: {
        decors: function (newValue) {
            if (newValue) {
                for (const [column, decorSet] of newValue.entries()) {
                    this.checkDuplicates(decorSet, column);
                }
            }
        }
    },
    computed: {
        wishlistIdProductPart() {
            if (!this.decors) {
                return '';
            }

            let wishlistId = '';

            this.decors.forEach((decorSet, index) => {
               wishlistId += '#' + decorSet[this.showedDecors[index]].pim_id
            });

            return wishlistId;
        },
        wishlistTitleProductPart() {
            if (!this.decors) {
                return '';
            }

            let wishlistTitle = '';

            this.decors.forEach((decorSet, index) => {
                if (wishlistTitle !== '') {
                    wishlistTitle += ', ';
                }
                wishlistTitle += decorSet[this.showedDecors[index]].title
            });

            return wishlistTitle;
        },
        roomdesignerButtonIsDisabled() {
            if (!this.decors) {
                return true;
            }
            return false;
        },
        roomdesignerModalData() {
            if (!this.showRoomdesignerModal) {
                return {};
            }
            return {
                data: this.showedDecors.map((i, index) => this.decors[index][i]),
                selectedDecors: this.showedDecors.map((i, index) => this.decors[index][i].title)
            };
        }
    },
    methods: {
        paletteIsOnWishlist() {
            if (!this.decors) {
                return true; // ;-)
            }
            const searchId = this.wishlistIdProductPart;

            const wishlistItems = cookieUtils.decodeCookieValue(cookieUtils.getCookie(`wishlist_${window.market}`));

            const re = new RegExp('decorset#[^#]+'+searchId);
            return Array.isArray(wishlistItems) ? wishlistItems.some((item) => item.match(re)) : false;
        },
        addToWishlist() {
            if (!this.paletteIsOnWishlist()) {

                // Name
                const wishlistItems = cookieUtils.decodeCookieValue(cookieUtils.getCookie(`wishlist_${window.market}`));
                let decorsetCount = 0;
                if (Array.isArray(wishlistItems)) {
                    decorsetCount = wishlistItems.reduce((sum, item) => {
                        if (item.indexOf('decorset#') === 0) {
                            return sum + 1
                        }
                        return sum;
                    }, 0);
                }
                const wishlistName = this.$t('decorPalette') + ' ' + (decorsetCount+1);

                const wishlistId = 'decorset#'+wishlistName+this.wishlistIdProductPart;

                shopUtilities.add('wishlist', wishlistId, {
                    id: wishlistId,
                    title: wishlistName + ' (' + this.wishlistTitleProductPart + ')'
                });
                this.$forceUpdate();

                if (!window.toasts) {
                    window.toasts = new SalToast();
                }
                window.toasts.createToast(this.$t('addedToWishlist'), '', window.toasts.types.INFO, {
                    label: this.$t('goToWishlist'),
                    link: window.page_wishlist,
                    target: '_self',
                    additionalClass: 'button button--primary icon--before icon--wishlist-empty'
                });
            }
        },
        checkDuplicates(decorSet, column, depth = null) {
            for (const [row, decor] of decorSet.entries()) {
                const continueRecursion = depth ? depth-1: decorSet.length;

                if (this.showedDecors[column] === row) {
                    if (continueRecursion > 0) {
                        if (this.showedDecorIds.indexOf(decor.pim_id) !== -1) {
                            this.nextDecor(column, decorSet.length)
                            this.checkDuplicates(decorSet, column, continueRecursion);
                            return
                        } else {
                            this.$set(this.showedDecorIds, column, decor.pim_id)
                            return
                        }
                    } else {
                        this.$set(this.showedDecorIds, column, decor.pim_id)
                        return
                    }
                }
            }
        },
        nextDecor(column, base) {
            const newValue = (this.showedDecors[column] + 1) % base;
            this.$set(this.showedDecors, column, newValue)
        },
        newSuggestion(column, base) {
            this.nextDecor(column, base);
            this.checkDuplicates(this.decors[column], column);

            if (typeof window.gtag === 'function') {
                window.gtag('event', 'shuffle', {
                    event_category: 'Moodboard',
                    value: column
                });
            }
        }
    },
}
</script>

<style lang="scss">
    @import "../base";
    @import "../app/animation";

    .moodboard__result {
        margin-top: 21px;

        @include media-breakpoint-only('md') {
            margin-top: 18px;
        }

        @include media-breakpoint-between('xs', 'sm') {
            margin-top: 12px;
        }

        .debug {
            border: 2px dashed rebeccapurple;
        }

        .result__headline {
            border-top: 0;
            margin-bottom: 21px;
            margin-top: 21px;
        }

        .result__placeholder {
            background-color: $pfl-color__gray-010;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 21px;

            @include media-breakpoint-only(xs) {
                width: 100%;
                padding-top: calc(50% - 17px);
                padding-bottom: calc(50% - 17px);
            }

            @include media-breakpoint-only(sm) {
                width: 248px;
                height: 248px;
            }

            @include media-breakpoint-only(md) {
                width: 235px;
                height: 235px;
            }

            @include media-breakpoint-only(lg) {
                width: 150px;
                height: 150px;
            }

            @include media-breakpoint-only(xl) {
                width: 200px;
                height: 200px;
            }

            .placeholder__spinner {
                @extend %animation--spinner;
                margin-right: 8px;
            }
        }
    }
</style>
